import { Controller } from '@hotwired/stimulus';

// data-source="[a,b,c]" の候補から HTML5 の <datalist> を生成し、入力欄に
// ネイティブのオートコンプリートを付ける(旧 bootstrap-typeahead(jQuery)の置換)。
// ネイティブ UI なので低ITリテラシー配慮としても素直に使える。
export default class extends Controller {
  static values = { source: String };

  connect() {
    const raw = this.sourceValue || '';
    const items = raw
      .replace(/^\[|\]$/g, '')
      .split(',')
      .map((s) => s.trim())
      .filter((s) => s !== '');
    if (items.length === 0) return;

    const listId = `datalist-${Math.abs(this.hashCode(this.element.name || raw))}`;
    const datalist = document.createElement('datalist');
    datalist.id = listId;
    items.forEach((item) => {
      const option = document.createElement('option');
      option.value = item;
      datalist.appendChild(option);
    });

    this.element.setAttribute('list', listId);
    this.element.insertAdjacentElement('afterend', datalist);
    this.datalist = datalist;
  }

  disconnect() {
    if (this.datalist) this.datalist.remove();
  }

  hashCode(str) {
    let hash = 0;
    for (let i = 0; i < str.length; i += 1) {
      hash = (hash << 5) - hash + str.charCodeAt(i);
      hash |= 0;
    }
    return hash;
  }
}
